import { render, staticRenderFns } from "./DeleteVideoModal.vue?vue&type=template&id=12224aeb&scoped=true"
import script from "./DeleteVideoModal.vue?vue&type=script&lang=js"
export * from "./DeleteVideoModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteVideoModal.vue?vue&type=style&index=0&id=12224aeb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12224aeb",
  null
  
)

export default component.exports